import { queryCache } from 'react-query';

import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import useResourceMutation from 'dpl/shared/fetching/hooks/useResourceMutation';
import { segmentReset } from 'dpl/util/analytics';
import {
  currentUserQueryDefinition,
  currentUserLoginMutationDefinition,
  currentUserLogoutMutationDefinition
} from 'dpl/shared/hooks/queryDefinitions';

export default function useCurrentUser() {
  const query = useResourceQuery(currentUserQueryDefinition);
  const {
    queryKey,
    isError,
    isFetching,
    isSuccess,
    value,
    fetch
  } = query;

  const [login] = useResourceMutation({
    ...currentUserLoginMutationDefinition,
    queryKey,
    config: {
      throwOnError: true
    }
  });
  const [logoutResource] = useResourceMutation({ ...currentUserLogoutMutationDefinition });

  async function logout() {
    const ret = await logoutResource();
    segmentReset();
    return ret;
  }

  let isLoggedIn = null;
  let isBreeder = null;
  let isBuyer = null;
  if (isError || (isSuccess && !value.data)) {
    isLoggedIn = false;
  } else if (isSuccess) {
    isLoggedIn = true;
    isBreeder = value.data.breeder;
    isBuyer = value.data.buyer;

    if (window.bugsnagClient) {
      window.bugsnagClient.user = {
        ...window.bugsnagClient.user,
        ...value.data
      };
    }
  }

  return {
    isBreeder,
    isBuyer,
    isFetching,
    isLoggedIn,
    login,
    logout,
    invalidate: () => queryCache.invalidateQueries(queryKey),
    value: value || {},
    fetch
  };
}
